<ion-header [translucent]="true">
    <ion-toolbar class="ion-no-padding">
        <!-- own row with the shared gutter, so title and close button align with the content -->
        <div class="guide-header">
            <h2 class="guide-title">{{HeaderTitle}}</h2>

            <ion-button title="fechar" class="guide-close" fill="clear" color="dark" shape="round" (click)="Close()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-vertical" [fullscreen]="true">

    <ion-grid class="full ion-no-margin">

        <ion-row *ngIf="Description">
            <ion-col size="12">
                <p class="guide-description">{{Description}}</p>
            </ion-col>
        </ion-row>

        <ion-row class="guide-items">
            <ion-col size="12" *ngFor="let item of Items">
                <div class="guide-item">
                    <span class="guide-item__icon" aria-hidden="true">
                        <ion-icon [name]="item.icon"></ion-icon>
                    </span>
                    <div class="guide-item__text">
                        <strong>{{item.title}}</strong>
                        <span>{{item.text}}</span>
                    </div>
                </div>
            </ion-col>
        </ion-row>

    </ion-grid>

</ion-content>

<ion-footer>
    <ion-toolbar>
        <div class="guide-footer">
            <ion-button fill="solid" color="primary" (click)="Close()">Entendi</ion-button>
        </div>
    </ion-toolbar>
</ion-footer>
